import { CALL_API } from '../../api/';
import { Schemas } from '../../api/schema';
import * as ActionTypes from './actionTypes';

const courses_endpoint = 'courses';


// Fetch all courses
const fetchCourses = (nextPageUrl) => ({
  [CALL_API]: {
    types: [
      ActionTypes.FETCH_COURSES_REQUEST,
      ActionTypes.FETCH_COURSES_SUCCESS,
      ActionTypes.FETCH_COURSES_FAILURE
      ],
    endpoint: nextPageUrl,
    schema: Schemas.COURSE_ARRAY,
    apiVersion: 'v2',
  }
});

// Fetch a single course
const fetchCourse = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.FETCH_COURSE_REQUEST,
      ActionTypes.FETCH_COURSE_SUCCESS,
      ActionTypes.FETCH_COURSE_FAILURE
      ],
    endpoint: `${courses_endpoint}/${id}`,
    schema: Schemas.COURSE,
    apiVersion: 'v2',
  }
});

// Load all courses action creator
export const loadCourses = (nextPage) => (dispatch, getState) => {
  
  const {
    nextPageUrl = courses_endpoint,
    pageCount = 0
  } = getState().pagination.coursesPaginated || {}

  if (pageCount > 0 && !nextPage) {
    return Promise.resolve();
  }
  if(pageCount > 0 && nextPage) {
    return dispatch({
      type: ActionTypes.NEXT_COURSES_PAGE
    });
  }
  return dispatch(fetchCourses(nextPageUrl));
};

// Load a single course action creator
export const loadCourse = (id, requiredFields = []) => (dispatch, getState) => {
  const course = getState().entities.courses[id];
  if (course && requiredFields.every(key => course.hasOwnProperty(key))) {
    return Promise.resolve();
  }
  return dispatch(fetchCourse(id));
};



// WEBPACK FOOTER //
// ./src/modules/courses/actions.js